import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IObjetoSeguradoResponse } from "src/app/domain/interfaces/objeto-segurado.interface";
import { IResponseData } from "src/app/domain/interfaces/response-data.interface";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root"
})
export class ObjetoSeguradoService {
	constructor(private http: HttpClient) {}

	getTagsByTypeProposeProductCoverage(request: any): Observable<any> {
		return this.http.post(`${environment.urlApi}/SafeObject/GetTagsByTypeProposeProductCoverage`, request);
	}

	getObjetoSeguradoByIdTipoDeProposta(payload: any): Observable<any> {
		return this.http.get(`${environment.urlApi}/SafeObject/GetByIdTipoDeProposta?idTipodeProposta=${payload}`);
	}

	getObjetoSeguradoByIdProdutoCobertura(payload: any): Observable<any> {
		return this.http.get(`${environment.urlApi}/SafeObject/GetByIdProdutoCobertura?idProdutoCobertura=${payload}`);
	}

	insert(payload: any): Observable<any> {
		// const httpOptions = {
		//   headers: new HttpHeaders({
		//     'Content-Type': 'application/xml',
		//     'Accept': 'application/xml',
		//     'Response-Type': 'text'
		//   })
		// }
		return this.http.post(`${environment.urlApi}/SafeObject/Insert`, payload);
	}

	update(payload: any): Observable<any> {
		// const httpOptions = {
		//   headers: new HttpHeaders({
		//     'Content-Type': 'application/xml',
		//     'Accept': 'application/xml',
		//     'Response-Type': 'text'
		//   })
		// }
		return this.http.post(`${environment.urlApi}/SafeObject/Update`, payload);
	}

	search(payload: any): Observable<any> {
		return this.http.post(`${environment.urlApi}/SafeObject/Filter`, payload);
	}

	getById(id: number): Observable<IResponseData<IObjetoSeguradoResponse>> {
		return this.http.get<IResponseData<IObjetoSeguradoResponse>>(`${environment.urlApi}/SafeObject/GetById?id=${id}`);
	}
}
